import React, { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { Link } from 'react-router-dom';

const NavMenu = () => {
    const {userState} = useContext(AuthContext);
    const isDoctor = userState.userType === "Doctor";
    const isPatient  = userState.userType === "Patient";
    const isAdmin =  userState.userType === "Admin";
       
    return ( 
        userState.isAuthenticated && 
             <ul className="main-nav">
                 {
                     !isAdmin && <li>
                                    <Link to={isDoctor ? '/doctordashboard' : '/patientdashboard'}>Home</Link>
                                </li>
                 }
                {isDoctor && <li className="has-submenu">
                    <a href="">Doctors <i className="fas fa-chevron-down"></i></a>
                    <ul className="submenu">
                        <li><a href="#/doctordashboard">Doctor Dashboard</a></li>
                        <li><a href="#/appointment">Appointments</a></li>
                        <li><a href="#/scheduletiming">Schedule Timing</a></li>
                        <li><a href="#/mypatients">Patients List</a></li>
                        <li><a href="chat-doctor.html">Chat</a></li>
                        <li><a href="#/invoice">Invoices</a></li>
                        <li><a href="#/doctorprofilesetting">Profile Settings</a></li>
                        <li><a href="reviews.html">Reviews</a></li>
                    </ul>
                </li>}

                {isPatient && <li className="has-submenu">
                    <a href="">Patients <i className="fas fa-chevron-down"></i></a>
                    <ul className="submenu">
                        <li><a href="#/search">Search Doctor</a></li>
                        <li><a href="#/patientdashboard">Patient Dashboard</a></li>
                        <li><a href="#/patientprofilesetting">Profile Settings</a></li>
                        <li><a href="#/patchangepassword">Change Password</a></li>
                    </ul>
                </li>}
            </ul>

     );
}
 
export default NavMenu;

